import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api/v1`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login") && !url.includes("/auth/verify-otp")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch (e) { /* fallthrough */ }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const d = e?.response?.data;
  if (d?.message) return d.message;
  if (typeof d?.detail === "string") return d.detail;
  return e?.message || "Something went wrong";
};

export const get = async (url, params) => (await api.get(url, { params })).data.data;
export const post = async (url, body, cfg) => (await api.post(url, body, cfg)).data;
export const patch = async (url, body) => (await api.patch(url, body)).data;
export const put = async (url, body) => (await api.put(url, body)).data;

export async function streamSSE(path, body, onDelta) {
  const res = await fetch(`${BASE}/api/v1${path}`, {
    method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    let m = "Request failed";
    try { m = (await res.json()).message; } catch (e) { /* ignore */ }
    throw new Error(m);
  }
  const sessionId = res.headers.get("X-Session-Id");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.replace(/^data: /, "");
      if (line === "[DONE]") continue;
      try {
        const j = JSON.parse(line);
        if (j.error) throw new Error(j.error);
        if (j.delta) onDelta(j.delta);
      } catch (e) { if (e.message && !e.message.startsWith("Unexpected")) throw e; }
    }
  }
  return { sessionId };
}

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
export const dt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const d = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
export const label = (s) => (s ? String(s).replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : "—");
export const PRODUCT = { PL: "Personal Loan", BL: "Business Loan", HL: "Home Loan", CL: "Car Loan" };
export const PRODUCT_OPTIONS = Object.entries(PRODUCT);
